import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { decryptAEStoString } from '../../utils/utilities';
import { ROUTES } from './url-constant';

const AdminProtectedRoute = ({ component }) => {
    let location = useLocation(),
        rawAccessToken = useSelector((state) => state?.adminAccessToken?.value);
        rawAccessToken = rawAccessToken
        ? decryptAEStoString(rawAccessToken)
        : rawAccessToken;


    if (!rawAccessToken) {
        return <Navigate to={ROUTES?.ADMIN?.ADMIN_LOGIN} state={{ from: location }} replace />
    }
    return component
}

export default AdminProtectedRoute
